function Roles(data) {
    this.list = this.createUserRoles(data);
}

Roles.prototype = Object.assign(Roles.prototype, {
    createUserRoles(rolesData) {
        return (
            rolesData &&
            rolesData.roleDetails &&
            rolesData.roleDetails
                .filter(roles => roles.roleStatus === 'ACTIVE')
                .map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const { roleName, roleId } = row;
        return {
            name: roleName,
            value: roleId,
        };
    },
});

export default Roles;
